addEventListener("turbo:before-stream-render", ((event) => {
  const fallbackToDefaultActions = event.detail.render

  event.detail.render = function (streamElement) {
    if (streamElement.action == "redirect") {
      const attributes = event.detail.newStream.attributes
      const recentRequests = Array.from(Turbo.session.recentRequests)
      const requestIdTriggering = attributes.request_id?.value
      const src = attributes.src?.value || "/"
      if (recentRequests.includes(requestIdTriggering)) return

      Turbo.visit(src)
    } else {
      fallbackToDefaultActions(streamElement)
    }
  }
}))
